export default {
  'app.dashboard.mqttServer': 'MqttServer',
  'app.dashboard.summary': 'Summary',
  'app.dashboard.summary.total': 'Total',
  'app.dashboard.summary.online': 'Online',
  'app.box.prompt.delete': 'Confirm to remove box {boxNos}.',
  'app.box.prompt.clean': 'Confirm to clean box {boxNos}.',
  'app.box.prompt.cleanSuccess': 'Box configuration cleanup successfully.',
  'app.box.prompt.cleanFailed': 'Box configuration cleanup failed.',
  'app.box.prompt.reboot': 'Confirm to reboot {boxNos}.',
  'app.box.prompt.typeError': 'Batch upgrades only support devices of the same type.',
  'app.box.prompt.offlineError': 'Box {boxNos} is not online.',
  'app.box.prompt.connectionSuccess': 'Box {boxNo} connection updated successfully.',
  'app.box.table.index': 'Index',
  'app.box.table.alias': 'Alias',
  'app.box.table.boxNo': 'BoxNo',
  'app.box.table.connectionState': 'ConnState',
  'app.box.table.templateState': 'TemplateState',
  'app.box.table.boxType': 'BoxType',
  'app.box.table.templateName': 'TemplateName',
  'app.box.table.plcCount': 'PlcCount',
  'app.box.table.variableCount': 'VariableCount',
  'app.box.table.networkType': 'Network',
  'app.box.table.lastOffline': 'LastOfflineTime',
  'app.box.table.operation': 'Operation',
  'app.box.table.operation.contact': 'Contact',
  'app.box.table.operation.detail': 'Detail',
  'app.box.table.operation.delete': 'Delete',
  'app.box.table.operation.edit': 'Edit',
  'app.box.toolbar.keyword': 'Search by name, sn',
  'app.box.toolbar.remark': 'Search remark',
  'app.box.toolbar.import': 'Import',
  'app.box.toolbar.cancel': 'Cancel',
  'app.box.toolbar.select': 'Select',
  'app.box.toolbar.checkAll': 'Check All',
  'app.box.toolbar.batch': 'Batch',
  'app.box.toolbar.batch.delete': 'Delete',
  'app.box.toolbar.batch.firmware': 'Upgrade',
  'app.box.toolbar.batch.template': 'UpdateTemplate',
  'app.box.toolbar.batch.connection': 'UpdateConnection',
  'app.box.toolbar.batch.time': 'UpdateTime',
  'app.box.toolbar.batch.tunnel': 'Tunnel',
  'app.box.toolbar.batch.reboot': 'Reboot',
  'app.box.toolbar.batch.clean': 'Clean',
  'app.box.toolbar.updateTemplate': 'UpdateTemplate',
  'app.box.toolbar.batchRetry': 'BatchRetry',
  'app.box.toolbar.upgradeFirmware': 'UpgradeFirmware',
  'app.box.toolbar.connectionState': 'ConnState',
  'app.box.toolbar.templateState': 'TemplateState',
  'app.box.toolbar.clear': 'Reset',
  'app.box.toolbar.search': 'Search',
  'app.box.toolbar.moreFilter': 'More Filter',
  'app.box.toolbar.filter.boxType': 'BoxType',
  'app.box.toolbar.filter.templateName': 'TemplateName',
  'app.box.toolbar.filter.remark': 'Label',
  'app.box.toolbar.filter.ok': 'Ok',
  'app.box.toolbar.filter.cancel': 'Cancel',
  'app.box.import.selectFile': 'SelectFile',
  'app.box.import.selectFile.placeholder': 'Please Select',
  'app.box.import.selectFile.message': 'Please select a file.',
  'app.box.import.downloadTemplate': 'Doenload',
  'app.box.import.boxSubType': 'SubType',
  'app.box.import.index': 'Index',
  'app.box.import.alias': 'Alias',
  'app.box.import.boxNo': 'BoxNo',
  'app.box.import.boxNo.message': 'FBox serial number can not be empty.',
  'app.box.import.userPassword': 'Password',
  'app.box.import.userPassword.message': 'FBox password can not be empty.',
  'app.box.import.tags': 'Tags',
  'app.box.import.ip': 'IP Addr',
  'app.box.import.ip.message': 'IP can not be empty.',
  'app.box.import.natIp': 'IP Addr',
  'app.box.import.search': 'Search',
  'app.box.import.find': 'Find',
  'app.box.import.add': 'Add',
  'app.box.import.importType': 'ImportType',
  'app.box.import.operation': 'Operation',
  'app.box.import.exists': '{boxNo}, already added.',
  'app.box.detail.title': 'FBox Detail',
  'app.box.detail.variable.title': 'Variable Detail',
  'app.box.detail.variable.pushStatus': 'PushStatus',
  'app.box.detail.variable.pushStatus.on': 'ON',
  'app.box.detail.variable.pushStatus.off': 'OFF',
  'app.box.detail.variable.value.title': 'Set data monitor value',
  'app.box.detail.variable.value': 'NewValue',
  'app.box.detail.variable.value.required': 'Value can not be null.',
  'app.box.detail.variable.value.required.range': 'Data out of range({min} ~ {max}).',
  'app.box.detail.variable.value.string': 'Please input string value',
  'app.box.detail.variable.value.decimal': 'Please input decimal value',
  'app.box.detail.variable.value.hex': 'Please input hexadecimal value',
  'app.box.detail.variable.value.binary': 'Please input binary value',
  'app.box.detail.variable.value.bcs': 'Please input bcd value',
  'app.box.detail.basic.title': 'Basic Info',
  'app.box.detail.basic.alias': 'Alias',
  'app.box.detail.basic.boxNo': 'SerialNumber',
  'app.box.detail.basic.connectionState': 'OnlineStatus',
  'app.box.detail.basic.contactTemplate': 'Template',
  'app.box.detail.basic.networkType': 'NetworkType',
  'app.box.detail.basic.carrier': 'Carrier',
  'app.box.detail.basic.tags': 'Tags',
  'app.box.detail.basic.tags.add': 'Add',
  'app.box.detail.basic.advanced': 'Advanced',
  'app.box.detail.system.title': 'System',
  'app.box.detail.audit.title': 'AuditLog',
  'app.box.detail.audit.clear': 'Reset',
  'app.box.detail.audit.search': 'Search',
  'app.box.detail.audit.index': 'Index',
  'app.box.detail.audit.creationTime': 'Time',
  'app.box.detail.audit.content': 'Detail',
  'app.box.detail.audit.creator': 'User',
  'app.box.detail.audit.type': 'Operation',
  'app.box.detail.audit.type.0': 'All',
  'app.box.detail.audit.type.1': 'Template',
  'app.box.detail.audit.type.2': 'Firmware',
  'app.box.detail.audit.type.3': 'Network',
  'app.box.detail.audit.type.4': 'Timezone',
  'app.box.detail.audit.type.5': 'APN',
  'app.box.detail.audit.type.6': 'EnablePush',
  'app.box.detail.audit.type.7': 'Reboot',
  'app.box.detail.audit.type.8': 'Connection',
  'app.box.detail.audit.type.9': 'EnableAlarm',
  'app.box.detail.audit.type.10': 'SetNetwork',
  'app.box.detail.audit.type.11': 'Reset',
  'app.box.detail.audit.type.12': 'SetMode',
  'app.box.detail.audit.type.13': 'WriteValue',
  'app.box.detail.audit.type.14': 'LogConfig',
  'app.box.detail.audit.type.15': 'LodUpload',
  'app.box.detail.audit.type.16': 'Clean',
  'app.box.detail.audit.template.1': 'TemplateName:【{templateName}】',
  'app.box.detail.audit.template.2': 'FirmwareVer:【{version}】',
  'app.box.detail.audit.template.3': 'Setting network type.',
  'app.box.detail.audit.template.4': 'Setting ntp parameters.',
  'app.box.detail.audit.template.5': 'Setting apn parameters.',
  'app.box.detail.audit.template.6': 'PushStatus:【{enableItemPush}】',
  'app.box.detail.audit.template.7': ' ',
  'app.box.detail.audit.template.8': 'Setting connection parameters.',
  'app.box.detail.audit.template.9': 'AlarmStatus: 【{enableItemPush}】 ',
  'app.box.detail.audit.template.10': ' ',
  'app.box.detail.audit.template.11': 'Restore factory settings.',
  'app.box.detail.audit.template.12': 'Setting connection parameters.',
  'app.box.detail.audit.template.13': ' ',
  'app.box.detail.audit.template.14': ' ',
  'app.box.detail.audit.template.15': ' ',
  'app.box.detail.audit.template.16': ' ',
  'app.box.detail.connection.title': 'Connection',
  'app.box.detail.logs.title': 'ConnectionLog',
  'app.box.detail.logs.index': 'Index',
  'app.box.detail.logs.content': 'Content',
  'app.box.detail.logs.timestamp': 'Timestamp',
  'app.box.detail.logs.action.0': 'Offline',
  'app.box.detail.logs.action.1': 'Online',
  'app.box.detail.logs.action.2': 'LoginValid',
  'app.box.detail.edit.save': 'Save',
  'app.box.detail.edit.networkMode': 'NetworkMode',
  'app.box.detail.edit.wan': 'WAN',
  'app.box.detail.edit.ipAddr': 'IPAddress',
  'app.box.detail.edit.ipAddr.message': 'IPAddress can not be empty.',
  'app.box.detail.edit.subnetMask': 'SubnetMask',
  'app.box.detail.edit.subnetMask.message': 'SubnetMask can not be empty.',
  'app.box.detail.edit.gateway': 'Gateway',
  'app.box.detail.edit.gateway.message': 'Gateway can not be empty.',
  'app.box.detail.edit.dns1.message': 'DNS1 can not be empty.',
  'app.box.detail.edit.wifi': 'WIFI',
  'app.box.detail.edit.scan': 'Scan',
  'app.box.detail.edit.cellular': 'Cellular',
  'app.box.detail.edit.apn.message': 'APN can not be empty.',
  'app.box.detail.edit.userName': 'UserName',
  'app.box.detail.edit.password': 'Password',
  'app.box.detail.edit.dialing': 'Dialing',
  'app.box.detail.edit.connection': 'Connection',
  'app.box.detail.edit.mode': 'Mode',
  'app.box.detail.edit.mode.message': 'Please select mode.',
  'app.box.detail.edit.server': 'Server',
  'app.box.detail.edit.server.message': 'Server address can not be empty.',
  'app.box.detail.edit.mqttVersion': 'Version',
  'app.box.detail.edit.mqttVersion.message': 'Please select mqtt version.',
  'app.box.detail.edit.connectTimeout': 'Timeout',
  'app.box.detail.edit.connectTimeout.message': 'Timeout can not be empty.',
  'app.box.detail.edit.keepAlive': 'Keep Alive',
  'app.box.detail.edit.keepAlive.message': 'Keep Alive can not be empty.',
  'app.box.detail.edit.cleansession': 'Clean Session',
  'app.box.detail.edit.certType': 'Cert Type',
  'app.box.detail.edit.caCrt': 'CA',
  'app.box.detail.edit.caCrt.message': 'CA cert can not be empty.',
  'app.box.detail.edit.clientCrt': 'Client Crt',
  'app.box.detail.edit.clientCrt.message': 'ClientCrt can not be empty.',
  'app.box.detail.edit.clientKey': 'Client Key',
  'app.box.detail.edit.clientKey.message': 'ClientKey can not be empty.',
  'app.box.detail.edit.time': 'Time',
  'app.box.detail.edit.ntpserverType': 'ServerType(NTP)',
  'app.box.detail.edit.ntpserver': 'Server',
  'app.box.detail.edit.ntpserver.message': 'Server can not be empty.',
  'app.box.detail.edit.timezone': 'TimeZone',
  'app.box.detail.edit.dateTime': 'DateTime',
  'app.box.detail.status.title': 'Device Status',
  'app.box.detail.status.basicInfo': 'Basic Info',
  'app.box.detail.status.connectionState': 'Connection Status',
  'app.box.detail.status.networkType': 'Network Type',
  'app.box.detail.status.boxType': 'Box Type',
  'app.box.detail.status.softVer': 'Firmware Ver',
  'app.box.detail.status.boxNo': 'Serial Number',
  'app.box.detail.status.userPassword': 'Password',
  'app.box.detail.status.connection': 'Device Mode',
  'app.box.detail.status.wan': 'WAN',
  'app.box.detail.status.lan': 'LAN',
  'app.box.detail.status.gprs': 'GPRS',
  'app.box.detail.status.wifi': 'WIFI',
  'app.box.detail.status.ipAddr': 'IP',
  'app.box.detail.status.subnetMask': 'SubnetMask',
  'app.box.detail.status.gateway': 'Gateway',
  'app.box.detail.status.dns1': 'DNS1',
  'app.box.detail.status.dns2': 'DNS2',
  'app.box.detail.status.lanIp': 'LAN IP',
  'app.box.detail.status.version': 'Version',
  'app.box.detail.status.hardware': 'Hardware Ver',
  'app.box.detail.status.fcs': 'FCS Ver',
  'app.box.detail.status.boot': 'Boot Ver',
  'app.box.detail.status.fds': 'FDS Ver',
  'app.box.detail.status.kernel': 'Kernel Ver',
  'app.box.detail.status.fgui': 'FGUI Ver',
  'app.box.detail.status.rootfs': 'FS Ver',
  'app.box.detail.status.floader': 'Floader Ver',
  'app.box.detail.template.title': 'Template',
  'app.box.detail.template.variable': 'Varibale',
  'app.box.detail.template.alarm': 'Alarm',
  'app.box.detail.template.macros': 'Macro',
  'app.box.detail.template.transfer': 'MQTT',
  'app.box.detail.template.plc': 'PLC',
  'app.box.detail.template.variable.status': 'Status',
  'app.box.detail.template.variable.status.msg': 'Select Status',
  'app.box.detail.template.variable.pushStatus': 'Push Status:',
  'app.box.detail.template.variable.readonly': 'ReadOnly',
  'app.box.detail.template.variable.plc.msg': 'Select Device',
  'app.box.detail.template.variable.name.msg': 'Name/Description',
  'app.box.detail.template.alarm.status': 'Status',
  'app.box.detail.template.alarm.value': 'Value',
  'app.box.detail.template.alarm.pushStatus': 'Push Status:',
  'app.box.list.title': 'FBox List',
  'app.box.list.search': 'Search',
  'app.box.list.context.edit': 'Edit',
  'app.box.list.context.favorite': 'Favorite',
  'app.box.list.context.delete': 'Delete',
  'app.box.list.context.export': 'Export',
  'app.box.list.context.firmware': 'Upgrade',
  'app.box.list.context.template': 'Template',
  'app.box.list.context.clean': 'Clean',
  'app.box.list.context.reboot': 'Reboot',
  'app.box.list.context.reset': 'Reset',
  'app.box.list.context.sub': 'More',
  'app.box.mqtt.certType.0': 'CA Signed',
  'app.box.mqtt.certType.1': 'Self Signed',
  'app.box.networkMode.1': 'Ethernet',
  'app.box.networkMode.2': 'WIFI',
  'app.box.networkMode.3': 'Cellular',
  'app.box.ipSource.0': 'DHCP',
  'app.box.ipSource.1': 'Static IP',
  'app.box.job.index': 'Index',
  'app.box.job.type': 'JobType',
  'app.box.job.type.1': 'TemplateDownload',
  'app.box.job.type.2': 'FirmwareUpgrade',
  'app.box.job.type.3': 'Reset',
  'app.box.job.type.4': 'Upgrade',
  'app.box.job.boxNo': 'SerialNumber',
  'app.box.job.progress': 'Progress',
  'app.box.job.message': 'Message',
  'app.box.job.creationTime': 'CreationTime',
  'app.box.job.state.1': 'Processing',
  'app.box.job.state.2': 'Success',
  'app.box.job.state.3': 'Failure',
  'app.box.upgrade.step.0': 'Start the upgrade.',
  'app.box.upgrade.step.1': 'Get device firmware information.',
  'app.box.upgrade.step.2': 'Get device PID.',
  'app.box.upgrade.step.3': 'Download the upgrade program.',
  'app.box.upgrade.step.4': 'Wait for the device to restart.',
  'app.box.upgrade.step.5': 'Getting firmware list.',
  'app.box.upgrade.step.6': 'Getting firmware libs.',
  'app.box.upgrade.step.7': 'Verifying file MD5.',
  'app.box.upgrade.step.8': 'Download the firmware.',
  'app.box.upgrade.step.9': 'Wait for the device to restart.',
  'app.box.upgrade.step.10': 'Device upgrade completed.',
  'app.box.upgrade.failed.title': 'Upgrade failed',
  'app.box.upgrade.failed.retry': 'Retry',
  'app.box.upgrade.failed.msg': 'Box upgrade failed.',
  'app.box.upgrade.boxTypeError': 'Box type error.',
  'app.template.prompt.delete': 'Confirm to remove templates {names}',
  'app.template.prompt.select': 'Please select template.',
  'app.template.modalTitle': 'Create Device',
  'app.template.edit.title': 'Edit Template: ({name})',
  'app.template.edit.title.create': 'Create Template',
  'app.template.edit.name': 'Name',
  'app.template.edit.name.copy': 'Copy',
  'app.template.edit.name.message': 'Template name is empty',
  'app.template.edit.remark': 'Remark',
  'app.template.toolbar.name.placeholder': 'Search by template name',
  'app.template.toolbar.remark.placeholder': 'Search by template remark',
  'app.template.toolbar.clean': 'Reset',
  'app.template.toolbar.search': 'Search',
  'app.template.toolbar.import': 'Import',
  'app.template.toolbar.create': 'Create',
  'app.template.toolbar.batch': 'Batch',
  'app.template.toolbar.batch.delete': 'Delete',
  'app.template.toolbar.batch.export': 'Export',
  'app.template.import.error.emptyName': 'Template name can not be empty.',
  'app.template.import.error.format': 'Template format error.',
  'app.template.apply.title': 'Apply Records',
  'app.template.table.menu.copy': 'Copy',
  'app.template.table.menu.delete': 'Delete',
  'app.template.table.menu.export': 'Export',
  'app.template.table.menu.edit': 'Edit',
  'app.template.table.menu.applyRecord': 'ApplyRecord',
  'app.template.table.index': 'Index',
  'app.template.table.name': 'Name',
  'app.template.table.applied': 'Applied',
  'app.template.table.applied.true': 'Yes',
  'app.template.table.applied.false': 'No',
  'app.template.table.plcCount': 'PlcCount',
  'app.template.table.variableCount': 'VariableCount',
  'app.template.table.transferProtocol': 'TransferProtocol',
  'app.template.table.remark': 'Remark',
  'app.template.table.operation': 'Operation',
  'app.template.table.operation.config': 'Config',
  'app.template.table.operation.apply': 'Apply',
  'app.template.tab.title': 'Template',
  'app.template.tab.plcs': 'PLC',
  'app.template.tab.variables': 'Variable',
  'app.template.tab.alarm': 'Alarm',
  'app.template.tab.macro': 'Macro',
  'app.template.tab.transfers': 'Transfer',
  'app.template.plc.existName': 'Plc name already exists.',
  'app.template.plc.toolbar.alias': 'Search by plc alias.',
  'app.template.plc.toolbar.plcName': 'Search by plc name.',
  'app.template.plc.toolbar.type': 'Type',
  'app.template.plc.toolbar.clear': 'Reset',
  'app.template.plc.toolbar.search': 'Search',
  'app.template.plc.toolbar.create': 'Create',
  'app.template.plc.toolbar.batchDelete': 'BatchDelete',
  'app.template.plc.table.index': 'Index',
  'app.template.plc.table.alias': 'Alias',
  'app.template.plc.table.plcName': 'PLC',
  'app.template.plc.table.communicationMode': 'Mode',
  'app.template.plc.table.operation': 'Operation',
  'app.template.plc.table.operation.edit': 'Edit',
  'app.template.plc.table.operation.delete': 'Delete',
  'app.template.plc.edit.title': 'Edit PLC: ({name})',
  'app.template.plc.edit.type': 'Type',
  'app.template.plc.edit.type.message': 'Please select Type',
  'app.template.plc.edit.deviceMode': 'DeviceMode',
  'app.template.plc.edit.deviceMode.message': 'Please select DeviceMode',
  'app.template.plc.edit.manufacturer': 'Manufacturer',
  'app.template.plc.edit.manufacturer.message': 'Please select Manufacturer',
  'app.template.plc.edit.plcName': 'PlcName',
  'app.template.plc.edit.plcName.message': 'Please select plc.',
  'app.template.plc.edit.alias': 'Alias',
  'app.template.plc.edit.alias.message': 'Alias can not be empty.',
  'app.template.plc.edit.broadcastStationNo': 'BroadcastStationNo',
  'app.template.plc.edit.slaveStationNo': 'SlaveStationNo',
  'app.template.plc.edit.portNo': 'PortNo',
  'app.template.plc.edit.workModel': 'WorkModel',
  'app.template.plc.edit.baudRate': 'BaudRate',
  'app.template.plc.edit.dataBits': 'DataBits',
  'app.template.plc.edit.stopBits': 'StopBits',
  'app.template.plc.edit.parity': 'Parity',
  'app.template.plc.edit.compatibleModels': 'CompatibleModels',
  'app.template.plc.edit.advance': 'Advance',
  'app.template.plc.edit.advance.package': 'Timeout & Package',
  'app.template.plc.edit.autoPackage': 'AutoPackage',
  'app.template.plc.edit.autoPackage.enable': 'Enable',
  'app.template.plc.edit.autoPackage.disable': 'Disable',
  'app.template.plc.edit.plcResponceTimeout': 'ResponceTimeout',
  'app.template.plc.edit.protocolInterval': 'Interval',
  'app.template.plc.edit.protocolTimeout1': 'Timeout1',
  'app.template.plc.edit.protocolTimeout2': 'Timeout2',
  'app.template.plc.edit.assembleIntervalBitReg': 'BitRegInterval',
  'app.template.plc.edit.assembleIntervalWordReg': 'WordRegInterval',
  'app.template.plc.edit.maxPacketsBitReg': 'MaxPacketsBitReg',
  'app.template.plc.edit.maxPacketsWordReg': 'MaxPacketsWordReg',
  'app.template.plc.edit.exceptions': 'Exceptions',
  'app.template.plc.edit.errMsgDispTime': 'ErrMsgDispTime',
  'app.template.plc.edit.byteOrder': 'ByteOrder',
  'app.template.plc.edit.byteOrder16': 'ByteOrder16',
  'app.template.plc.edit.byteOrder32': 'ByteOrder32',
  'app.template.plc.edit.byteOrderFloat': 'ByteOrderFloat',
  'app.template.plc.edit.references': 'Note: This device has been referenced by {refs}. Please unreference and edit it.',
  'app.template.variable.batchLimit': 'Batch range {min}~{max}',
  'app.template.variable.existName': 'Variable name already exists',
  'app.template.variable.plcEmpty': 'Device list can not be empty.',
  'app.template.variable.edit.title': 'Edit Variable: ({name})',
  'app.template.variable.edit.title.batch': 'Batch Create Variable',
  'app.template.variable.edit.name': 'Name',
  'app.template.variable.edit.name.message': 'Name cannot be empty',
  'app.template.variable.edit.deviceId': 'DeviceId',
  'app.template.variable.edit.stationNo': 'StationNo',
  'app.template.variable.edit.dataType': 'DataType',
  'app.template.variable.edit.registerName': 'RegisterName',
  'app.template.variable.edit.registerName.message': 'RegisterName cannot be empty',
  'app.template.variable.edit.enabledIndex': 'BitIndex',
  'app.template.variable.edit.enabledIndex.desc': 'Bit-index within a Byte Register',
  'app.template.variable.edit.enabledIndex.macroDesc': '(Reference in macro is not supported when enabled.)',
  'app.template.variable.edit.mainAddress': 'MainAddress',
  'app.template.variable.edit.subIndex': 'SubIndex',
  'app.template.variable.edit.integerDigits': 'IntegerDigits',
  'app.template.variable.edit.fractionDigits': 'FractionDigits',
  'app.template.variable.edit.fractionDigits.message': 'FractionDigits cannot be empty',
  'app.template.variable.edit.privilege': 'Privilege',
  'app.template.variable.edit.encoding': 'Encoding',
  'app.template.variable.edit.order': 'ByteOrder',
  'app.template.variable.edit.format': 'Format',
  'app.template.variable.edit.unit': 'Unit',
  'app.template.variable.edit.charCount': 'CharCount',
  'app.template.variable.edit.batch': 'Batch',
  'app.template.variable.edit.batch.message': 'Batch type cannot be empty',
  'app.template.variable.edit.batch.increment': 'Increment',
  'app.template.variable.edit.batch.increment.message': 'Increment cannot be empty',
  'app.template.variable.edit.batch.count': 'BatchCount',
  'app.template.variable.edit.batch.count.message': 'BatchCount cannot be empty',
  'app.template.variable.edit.valueTransform': 'Transform',
  'app.template.variable.edit.valueTransform.0': 'Disable',
  'app.template.variable.edit.valueTransform.1': 'Scale',
  'app.template.variable.edit.valueTransform.2': 'Zoom',
  'app.template.variable.edit.valueTransform.maxValue': 'Upper Limit',
  'app.template.variable.edit.valueTransform.minValue': 'Lower Limit',
  'app.template.variable.edit.valueTransform.scaleMaxValue': 'Scale Max Limit',
  'app.template.variable.edit.valueTransform.scaleMinValue': 'Scale Min Limit',
  'app.template.variable.edit.valueTransform.gain': 'Gain',
  'app.template.variable.edit.valueTransform.offset': 'Offset',
  'app.template.variable.edit.deadZone': 'DeadZone',
  'app.template.variable.edit.description': 'Description',
  'app.template.variable.edit.references': 'Note: this variable has been referenced by {refs}. Please unreference and edit it.',
  'app.template.variable.edit.references.macro': 'Go to update the macro script after releasing references.',
  'app.template.variable.toolbar.name': 'Search by name',
  'app.template.variable.toolbar.description': 'Search by description',
  'app.template.variable.toolbar.clear': 'Reset',
  'app.template.variable.toolbar.search': 'Search',
  'app.template.variable.toolbar.create': 'Create',
  'app.template.variable.toolbar.create.batch': 'BatchCreate',
  'app.template.variable.toolbar.batchDelete': 'BatchDelete',
  'app.template.variable.table.index': 'Index',
  'app.template.variable.table.name': 'Name',
  'app.template.variable.table.deviceId': 'DeviceId',
  'app.template.variable.table.mainAddress': 'MainAddress',
  'app.template.variable.table.data': 'Data',
  'app.template.variable.table.remark': 'Description',
  'app.template.variable.table.operation': 'Operation',
  'app.template.variable.table.operation.edit': 'Edit',
  'app.template.variable.table.operation.delete': 'Delete',
  'app.template.alarm.toolbar.name': 'Name',
  'app.template.alarm.toolbar.clear': 'Clear',
  'app.template.alarm.toolbar.search': 'Search',
  'app.template.alarm.toolbar.create': 'Create',
  'app.template.alarm.toolbar.batchDelete': 'BatchDelete',
  'app.template.alarm.table.index': 'Index',
  'app.template.alarm.table.name': 'Name',
  'app.template.alarm.table.condition': 'Condition',
  'app.template.alarm.table.address': 'Address',
  'app.template.alarm.table.msg': 'Message',
  'app.template.alarm.table.operation': 'Operation',
  'app.template.alarm.table.operation.edit': 'Edit',
  'app.template.alarm.table.operation.delete': 'Delete',
  'app.template.alarm.operator.0': 'OFF',
  'app.template.alarm.operator.1': 'ON',
  'app.template.alarm.condition.0': '<>',
  'app.template.alarm.condition.1': '=',
  'app.template.alarm.condition.2': '>',
  'app.template.alarm.condition.3': '>=',
  'app.template.alarm.condition.4': '<',
  'app.template.alarm.condition.5': '<=',
  'app.template.alarm.conditionMethod.0': 'None',
  'app.template.alarm.conditionMethod.1': 'And',
  'app.template.alarm.conditionMethod.2': 'Or',
  'app.template.alarm.value': 'Value',
  'app.template.alarm.existName': 'Duplicate alarm name.',
  'app.template.alarm.edit.title': 'Edit Alarm: ({name})',
  'app.template.alarm.edit.variableId': 'Variable',
  'app.template.alarm.edit.variableId.message': 'Variable cannot be empty.',
  'app.template.alarm.edit.name': 'Name',
  'app.template.alarm.edit.name.message': 'Alarm name cannot be empty.',
  'app.template.alarm.edit.deadValue': 'DeadValue',
  'app.template.alarm.edit.msg': 'Content',
  'app.template.alarm.edit.msg.message': 'Alarm content cannot be empty.',
  'app.template.alarm.edit.references': ' Note: this alarm has been referenced by {refs}. Please unreference and edit it.',
  'app.template.macro.existName': 'Duplicate macro script name.',
  'app.template.macro.table.index': 'Index',
  'app.template.macro.table.name': 'Name',
  'app.template.macro.table.description': 'Description',
  'app.template.macro.table.operation': 'Operation',
  'app.template.macro.table.operation.edit': 'Edit',
  'app.template.macro.table.operation.delete': 'Delete',
  'app.template.macro.toolbar.name': 'Name',
  'app.template.macro.toolbar.clear': 'Clear',
  'app.template.macro.toolbar.search': 'Search',
  'app.template.macro.toolbar.create': 'Create',
  'app.template.macro.toolbar.batchDelete': 'BatchDelete',
  'app.template.macro.edit.title': 'Edit Macro: ({name})',
  'app.template.macro.edit.name': 'Name',
  'app.template.macro.edit.name.message': 'Name can not be empty.',
  'app.template.macro.edit.description': 'Description',
  'app.template.macro.edit.saveClose': 'Save&Close',
  'app.template.macro.edit.save': 'Save',
  'app.template.macro.edit.save.message': 'Give up unsaved changes?',
  'app.template.macro.edit.help': 'Help',
  'app.template.macro.edit.docTitle': 'Function Document',
  'app.template.macro.editor.output': 'Output',
  'app.template.macro.editor.watch': 'Watch',
  'app.template.macro.editor.variable': 'Variable',
  'app.template.macro.editor.offset': 'Offset',
  'app.template.macro.editor.value': 'Value',
  'app.template.macro.plan': 'Execution Plan',
  'app.template.macro.plan.title': 'Set Execution Plan',
  'app.template.macro.plan.mode': 'Mode',
  'app.template.macro.plan.mode.0': 'Execute On Startup',
  'app.template.macro.plan.mode.1': 'Cycle Execution',
  'app.template.macro.plan.mode.2': 'Conditional Execution',
  'app.template.macro.plan.cycle': 'Cycle',
  'app.template.macro.plan.variable': 'Variable',
  'app.template.macro.plan.variable.message': 'Variable can not be empty.',
  'app.template.macro.plan.condition': 'Condition',
  'app.template.macro.plan.condition.message': 'Condition can not be empty.',
  'app.template.macro.variable.contact': 'Contact Variable',
  'app.template.macro.variable.title': 'Select Variables',
  'app.template.transfer.config.create': 'Create',
  'app.template.transfer.config.combination': 'Combination',
  'app.template.transfer.config.combination.title': 'Create Combination',
  'app.template.transfer.config.combination.title.edit': 'Create Combination: ({name})',
  'app.template.transfer.config.combination.name': 'Name',
  'app.template.transfer.config.combination.name.message': 'Name can not be empty.',
  'app.template.transfer.config.combination.format': 'Format',
  'app.template.transfer.config.combination.format.message': 'Format can not be empty.',
  'app.template.transfer.config.combination.format.preview': 'Preview',
  'app.template.transfer.config.combination.description': 'Description',
  'app.template.transfer.config.combination.operation': 'Operation',
  'app.template.transfer.config.combination.operation.edit': 'Edit',
  'app.template.transfer.config.combination.operation.delete': 'Delete',
  'app.template.transfer.config.combination.delete.message': 'It cannot be restored after deletion. Be sure to continue?',
  'app.template.transfer.config.timestamp': 'Timestamp',
  'app.template.transfer.config.timestamp.title': 'Create Timestamp',
  'app.template.transfer.config.timestamp.title.edit': 'Edit Timestamp: ({name})',
  'app.template.transfer.config.timestamp.name': 'Name',
  'app.template.transfer.config.timestamp.name.message': 'Name can not be empty.',
  'app.template.transfer.config.timestamp.format': 'Format',
  'app.template.transfer.config.timestamp.format.message': 'Format can not be empty.',
  'app.template.transfer.config.timestamp.zone': 'Zone',
  'app.template.transfer.config.timestamp.description': 'Description',
  'app.template.transfer.config.timestamp.format.preview': 'Preview',
  'app.template.transfer.config.timestamp.operation': 'Operation',
  'app.template.transfer.config.timestamp.operation.edit': 'Edit',
  'app.template.transfer.config.timestamp.operation.delete': 'Delete',
  'app.template.transfer.protocol.name': 'Name',
  'app.template.transfer.protocol.name.message': 'Name cannot be empty',
  'app.template.transfer.protocol.name.exists': 'Name already exists.',
  'app.template.transfer.protocol.serverUrl': 'Host',
  'app.template.transfer.protocol.serverUrl.message': 'Host cannot be empty',
  'app.template.transfer.protocol.serverPort': 'Port',
  'app.template.transfer.protocol.serverPort.message': 'Port cannot be empty',
  'app.template.transfer.protocol.serverPath': 'Path',
  'app.template.transfer.protocol.serverPath.message': 'Path cannot be empty',
  'app.template.transfer.protocol.clientId': 'ClientId',
  'app.template.transfer.protocol.clientId.message': 'ClientId cannot be empty',
  'app.template.transfer.protocol.clientId.exists': 'ClientId already exists.',
  'app.template.transfer.protocol.mqttVersion': 'MQTTVer',
  'app.template.transfer.protocol.mqttVersion.message': 'Please select MQTT ver',
  'app.template.transfer.protocol.keepAlive': 'KeepAlive',
  'app.template.transfer.protocol.keepAlive.message': 'KeepAlive can not be empty',
  'app.template.transfer.protocol.pubMode': 'PushMode',
  'app.template.transfer.protocol.pubMode.message': 'Please select PushMode',
  'app.template.transfer.protocol.pubInterval': 'PubInterval',
  'app.template.transfer.protocol.pubInterval.message': 'PubInterval can not be empty',
  'app.template.transfer.protocol.withAuthen': 'Authentication',
  'app.template.transfer.protocol.username': 'UserName',
  'app.template.transfer.protocol.username.message': 'UserName can not be empty',
  'app.template.transfer.protocol.password': 'Password',
  'app.template.transfer.protocol.password.message': 'Password can not be empty',
  'app.template.transfer.protocol.connectionType': 'ConnType',
  'app.template.transfer.protocol.clientCrt': 'ClientCrt',
  'app.template.transfer.protocol.caCrt': 'CA',
  'app.template.transfer.protocol.clientKey': 'ClientKey',
  'app.template.transfer.protocol.timestamp': 'Timestamp',
  'app.template.transfer.protocol.offlineCaching': 'Caching',
  'app.template.transfer.protocol.store': 'StoreMode',
  'app.template.transfer.protocol.store.message': 'Please select StoreMode',
  'app.template.transfer.protocol.cacheTime': 'CacheTime',
  'app.template.transfer.protocol.cacheTime.message': 'CacheTime can not be empty',
  'app.template.transfer.protocol.cacheGetTime': 'SamplingInterval',
  'app.template.transfer.protocol.cacheGetTime.message': 'SamplingInterval can not be empty',
  'app.template.transfer.protocol.edit': 'Edit',
  'app.template.transfer.protocol.copy': 'Copy',
  'app.template.transfer.protocol.delete': 'Delete',
  'app.template.transfer.protocol.enable': 'Enable',
  'app.template.transfer.protocol.enable.true': 'Disable',
  'app.template.transfer.protocol.enable.false': 'Enable',
  'app.template.transfer.protocol.create': 'Create',
  'app.template.transfer.protocol.create.edit': 'Edit: ({name})',
  'app.template.transfer.protocol.general': 'General',
  'app.template.transfer.protocol.verification': 'Authentication',
  'app.template.transfer.protocol.connection': 'Connection',
  'app.template.transfer.protocol.other': 'Other',
  'app.template.transfer.protocol.compression': 'Compression',
  'app.template.transfer.protocol.compress': 'Enable',
  'app.template.transfer.protocol.compress.type': 'Type',
  'app.template.transfer.connection.search': 'Search',
  'app.template.transfer.connection.search.clean': 'Reset',
  'app.template.transfer.connection.search.name': 'Search by name',
  'app.template.transfer.connection.search.function': 'Select Function',
  'app.template.transfer.connection.create': 'Create',
  'app.template.transfer.connection.create.edit': 'Edit: ({name})',
  'app.template.transfer.connection.index': 'Index',
  'app.template.transfer.connection.name': 'Name',
  'app.template.transfer.connection.name.message': 'Name can not be empty',
  'app.template.transfer.connection.function': 'Function',
  'app.template.transfer.connection.function.message': 'Please select Function',
  'app.template.transfer.connection.alarmEvent': 'Alarm',
  'app.template.transfer.connection.alarmEvent.message': 'Please select alarm.',
  'app.template.transfer.connection.alarmEvent.time': 'Time',
  'app.template.transfer.connection.alarmEvent.time.message': 'Time can not be empty',
  'app.template.transfer.connection.alarmEvent.before': 'Before',
  'app.template.transfer.connection.alarmEvent.after': 'After',
  'app.template.transfer.connection.alarmEvent.unit': 's',
  'app.template.transfer.connection.operation': 'Operation',
  'app.template.transfer.connection.operation.edit': 'Edit',
  'app.template.transfer.connection.operation.delete': 'Delete',
  'app.template.transfer.connection.pub': 'Pub',
  'app.template.transfer.connection.sub': 'Sub',
  'app.template.transfer.connection.variable.name': 'Name',
  'app.template.transfer.connection.variable.dataType': 'DataType',
  'app.template.transfer.connection.variable.description': 'Description',
  'app.template.transfer.connection.variable.privilege': 'Privilege',
  'app.template.transfer.connection.variable.contact': 'Contact',
  'app.template.transfer.connection.variable.internal': 'Internal',
  'app.template.transfer.connection.variable.item': 'DataMonitor',
  'app.template.transfer.connection.variable.item.alarm': 'Alarm',
  'app.template.transfer.connection.variable.combination': 'Combination',
  'app.template.transfer.connection.alarm.name': 'Name',
  'app.template.transfer.connection.alarm.dataType': 'DataType',
  'app.template.transfer.connection.alarm.msg': 'Message',
  'app.template.transfer.connection.editableTable.anonymousName': 'MqttVariableName',
  'app.template.transfer.connection.editableTable.valueType': 'ValueType',
  'app.template.transfer.connection.editableTable.variableName': 'VariableName',
  'app.template.transfer.connection.editableTable.defaultValue': 'DefaultValue',
  'app.template.transfer.connection.editableTable.operation': 'operation',
  'app.template.transfer.connection.editableTable.topic': 'Topic',
  'app.template.transfer.connection.editableTable.create': 'Create',
  'app.template.transfer.connection.editableTable.import': 'Import',
  'app.template.transfer.connection.editableTable.cacheTopic': 'CacheTopic',
  'app.template.transfer.table.index': 'Index',
  'app.template.transfer.table.name': 'Name',
  'app.template.transfer.table.host': 'Host',
  'app.template.transfer.table.pubMode': 'PubMode',
  'app.template.transfer.table.enable': 'Enable',
  'app.template.code.0': 'Published',
  'app.template.code.1': 'Timeout',
  'app.template.code.2': 'System Exception',
  'app.template.code.1001': 'The PLC feature is not supported.',
  'app.template.code.1002': 'The variable feature is not supported.',
  'app.template.code.1003': 'The mqtt feature is not supported.',
  'app.template.code.1004': 'The firmware upgrade feature is not supported.',
  'app.template.code.1005': 'The network feature is not supported.',
  'app.template.code.1006': 'The ntp feature is not supported.',
  'app.template.code.1007': 'The apn feature is not supported.',
  'app.template.code.1008': 'The connection feature is not supported.',
  'app.template.code.1009': 'The vpn feature is not supported.',
  'app.template.code.1010': 'The alarm feature is not supported.',
  'app.template.code.1011': 'The macro feature is not supported.',
  'app.template.code.10011': 'Error(10011)',
  'app.template.code.10012': 'Error(10012)',
  'app.template.code.10013': 'Error(10013)',
  'app.template.code.10014': 'Error(10014)',
  'app.template.code.10015': 'Error(10015)',
  'app.template.code.20001': 'Error(20001)',
  'app.template.code.20002': 'Error(20002)',
  'app.template.code.30001': 'Error(30001)',
  'app.template.code.30002': 'Error(30002)',
  'app.template.code.40001': 'Error(40001)',
  'app.template.code.40002': 'Error(40002)',
  'app.template.code.40003': 'Error(40003)',
  'app.template.code.40004': 'Error(40004)',
  'app.template.code.40005': 'Error(40005)',
  'app.template.code.50001': 'Error(50001)',
  'app.template.code.50002': 'Error(50002)',
  'app.template.code.50003': 'Error(50003)',
  'app.template.code.50004': 'Error(50004)',
  'app.template.code.50005': 'Error(50005)',
  'app.template.code.50006': 'Error(50006)',
  'app.template.code.60001': 'Error(60001)',
  'app.template.code.60002': 'Error(60002)',
  'app.template.code.80001': 'Error(80001)',
  'app.template.code.80002': 'Error(80002)',
  'app.template.code.80003': 'Error(80003)',
  'app.template.code.80004': 'Error(80004)',
  'app.template.code.90001': 'Error(90001)',
  'app.template.code.90002': 'Error(90002)',
  'app.template.code.90003': 'Error(90003)',
  'app.template.code.100001': 'Error(100001)',
  'app.template.code.100002': 'Error(100002)',
  'app.template.code.100003': 'Error(100003)',
  'app.template.code.100004': 'Error(100004)',
  'app.template.code.100005': 'Error(100005)',
  'app.template.code.110001': 'Error(110001)',
  'app.template.reference.objectType': 'Type',
  'app.template.reference.objectType.0': 'PLC',
  'app.template.reference.objectType.1': 'Variable',
  'app.template.reference.objectType.2': 'Alarm',
  'app.template.reference.objectType.3': 'Macro',
  'app.template.reference.objectType.4': 'Transfer',
  'app.template.reference.objectType.5': 'MacroCondition',
  'app.template.reference.view': 'View',
  'app.firmware.table.index': 'Index',
  'app.firmware.table.mainVer': 'Version',
  'app.firmware.table.verDetail': 'VerInfo',
  'app.firmware.table.boxTypes': 'Supports',
  'app.firmware.table.remark': 'Remark',
  'app.drive.table.index': 'Index',
  'app.drive.table.manufacturer': 'Manufacturer',
  'app.drive.table.type': 'Type',
  'app.drive.table.deviceMode': 'DeviceMode',
  'app.drive.table.plcName': 'Name',
  'app.server.edit.type': 'Type',
  'app.server.edit.type.message': 'Server type must be selected',
  'app.server.edit.apiUrl': 'API Server',
  'app.server.edit.apiUrl.message': 'API Server can not be empty',
  'app.server.edit.apiVersion': 'API Version',
  'app.server.edit.apiVersion.message': 'API Version can not be empty',
  'app.server.edit.appId': 'AppID',
  'app.server.edit.appId.message': 'AppID can not be empty',
  'app.server.edit.appSecret': 'AppSecret',
  'app.server.edit.appSecret.message': 'AppSecret can not be empty',
  'app.server.edit.mqttAddress': 'MQTT Host',
  'app.server.edit.mqttAddress.message': 'MQTT host can not be empty',
  'app.server.edit.save': 'Save',
  'app.user.table.index': 'Index',
  'app.user.table.userName': 'UserName',
  'app.user.table.userName.placeholder': 'Please input userName.',
  'app.user.table.userName.message': 'User name only supports alphanumeric or underscore.',
  'app.user.table.password': 'Password',
  'app.user.table.password.placeholder': 'Please input password.',
  'app.user.table.password.message.number': 'At least one number.',
  'app.user.table.password.message.uppercase': 'At least one uppercase letter.',
  'app.user.table.password.message.lowercase': 'At least one lowercase letter.',
  'app.user.table.password.message.special': 'At least one special character.',
  'app.user.table.email': 'Email',
  'app.user.table.email.placeholder': 'Please input Email.',
  'app.user.table.email.message': 'E-mail format is incorrect.',
  'app.user.table.roles': 'Roles',
  'app.user.table.roles.placeholder': 'Please select role.',
  'app.user.table.roles.message': 'User role can not be empty.',
  'app.user.table.lockoutEnabled': 'Lockout',
  'app.user.table.operation': 'Operation',
  'app.user.table.operation.delete': 'Delete',
  'app.user.toolbar.create': 'Create',
  'app.user.confirm.delete': 'Be sure to delete the user and all the data under the user? This process is unrecoverable!',
  'app.system.register.name': 'Name',
  'app.system.register.name.placeholder': 'Please input name.',
  'app.system.register.address': 'Address',
  'app.system.register.dataWidth': 'DataWidth',
  'app.system.register.description': 'Description',
  'app.system.register.search': 'Search',
  'app.connectionState.0': 'Unknown',
  'app.connectionState.1': 'Online',
  'app.connectionState.2': 'Timeout',
  'app.connectionState.3': 'Offline',
  'app.boxType.0': 'FBox',
  'app.boxType.1': 'FBox-Mini',
  'app.boxType.2': 'FBox-Lite',
  'app.boxType.3': 'FBox-Vpn',
  'app.boxType.4': 'FBox-Lite',
  'app.boxType.5': 'FLink',
  'app.boxType.6': 'FL3',
  'app.boxType.7': 'FBox-Lite',
  'app.boxType.8': 'HMI',
  'app.boxType.16': 'NBIot',
  'app.subType.1': 'Ethernet',
  'app.subType.2': '2G',
  'app.subType.3': '3G',
  'app.subType.4': 'WIFI',
  'app.subType.5': '4G',
  'app.subType.7': '4G',
  'app.subType.8': '5G',
  'app.networkType.0': 'Unknown',
  'app.networkType.1': 'Ethernet',
  'app.networkType.2': '2G',
  'app.networkType.3': '3G',
  'app.networkType.4': 'Wifi',
  'app.networkType.5': '4G',
  'app.templateState.0': 'NotPublish',
  'app.templateState.1': 'Publishing',
  'app.templateState.2': 'Published',
  'app.templateState.3': 'PublishFailed',
  'app.template.progress.status.0': 'normal',
  'app.template.progress.status.1': 'active',
  'app.template.progress.status.2': 'success',
  'app.template.progress.status.3': 'exception',
  'app.parity.0': 'None',
  'app.parity.1': 'OddParity',
  'app.parity.2': 'EvenParity',
  'app.portNo.0': 'COM1',
  'app.portNo.1': 'COM2',
  'app.portNo.2': 'COM3',
  'app.deviceMode.0': 'Master',
  'app.deviceMode.1': 'Slave',
  'app.plcType.serial': 'Serial',
  'app.plcType.ethernet': 'Ethernet',
  'app.plcType.local': 'Local',
  'app.plcStatus': 'Reading',
  'app.plcStatus.offline': 'FBox offline',
  'app.plcStatus.0': 'Normal',
  'app.plcStatus.1': 'Timeout',
  'app.plcStatus.2': 'Exception',
  'app.alarmStatus.0': 'Normal',
  'app.alarmStatus.1': 'Trigger',
  'app.communicationMode.local': 'None',
  'app.dataType.0': 'Bit',
  'app.dataType.1': '16-Bit UnSigned',
  'app.dataType.2': '16-Bit Signed',
  'app.dataType.3': '16-Bit BCD',
  'app.dataType.4': '16Bit Hex',
  'app.dataType.5': '16Bit Binary',
  'app.dataType.11': '32-Bit UnSigned',
  'app.dataType.12': '32-Bit Signed',
  'app.dataType.13': '32-Bit BCD',
  'app.dataType.14': '32Bit Hex',
  'app.dataType.15': '32Bit Binary',
  'app.dataType.16': '32-Bit Float',
  'app.dataType.30': 'String',
  'app.dataType.999': 'long,string',
  'app.dataType.998': 'int,string',
  'app.dataType.997': 'uint,string',
  'app.dataType.996': 'float,string',
  'app.dataType.995': 'string',
  'app.dataType.994': 'uint',
  'app.dataType.993': 'int',
  'app.dataType.992': 'boolean',
  'app.dataType.991': 'string,int',
  'app.privilege.2': 'Writeonly',
  'app.privilege.4': 'Readonly',
  'app.privilege.6': 'Read/Write',
  'app.protocol.mqtt': 'MQTT',
  'app.protocol.mqtt.internal': 'Internal',
  'app.protocol.mqtt.flexem': 'Flexem',
  'app.mqtt.pubMode.interval': 'Interval',
  'app.mqtt.pubMode.changed': 'Changed',
  'app.mqtt.connectionType.raw_tcp': 'TCP',
  'app.mqtt.connectionType.secure_tcp': 'Secure TCP',
  'app.mqtt.connectionType.raw_websocket': 'Websocket',
  'app.mqtt.connectionType.secure_websocket': 'Secure Websocket',
  'app.mqtt.connectionType.local': 'Local',
  'app.mqtt.connectionType.sd': 'SD Card',
  'app.mqtt.connectionType.usb': 'U Disk',
  'app.mqtt.function.PushMonitorData': 'PushMonitorData',
  'app.mqtt.function.PushAlarm': 'PushAlarm',
  'app.mqtt.function.WriteItem': 'WriteItem',
  'app.mqtt.function.Suspend': 'Suspend',
  'app.mqtt.function.SetReboot': 'Reboot',
  'app.mqtt.function.SetPushMethod': 'SetPushMethod',
  'app.mqtt.function.ReadItem': 'ReadItem',
  'app.mqtt.function.GetFBoxInfo': 'GetFBoxInfo',
  'app.mqtt.function.GetPicture': 'GetPicture',
  'app.mqtt.function.PushRegisterMsg': 'PushDeviceRegister',
  'app.mqtt.function.PushAlarmEvent': 'PublishAlarmListenData',
  'app.mqtt.variable.flexem_timestamp.desc': 'MQTT clients must have a timestamp when interacting with the server to determine the time point at which data is sent and received',
  'app.mqtt.variable.flexem_message_id.desc': 'Customer custom value field, returns the modified value as is',
  'app.mqtt.variable.flexem_alarm.desc': 'Alarm message push("alarm":alarm trigger restore,:alarm recover)',
  'app.mqtt.variable.flexem_message.desc': 'Returns description of the status after the operation',
  'app.mqtt.variable.flexem_error_code.desc': 'The status code returned after the operation',
  'app.mqtt.variable.gy_deviceId.desc': 'The id number of the device defined by the root cloud, take to write the name of the last three parts of the monitoring point reply topic',
  'app.mqtt.variable.gy_error_code.desc': 'Error code defined by the root cloud, string type',
  'app.mqtt.variable.flexem_info_type.desc': 'Publish FBox information,"location":get location,"status":get status',
  'app.mqtt.variable.flexem_sim_lac.desc': 'Base station:LAC',
  'app.mqtt.variable.flexem_sim_cel.desc': 'Base station:CellId',
  'app.mqtt.variable.flexem_sim_mcc.desc': 'Base station:MCC',
  'app.mqtt.variable.flexem_sim_mnc.desc': 'Base station:MNC',
  'app.mqtt.variable.flexem_sim_ccid.desc': 'ICCID',
  'app.mqtt.variable.flexem_longitude.desc': 'GPS-Longitude',
  'app.mqtt.variable.flexem_latitude.desc': 'GPS-Latitude',
  'app.mqtt.variable.flexem_push_interval.desc': 'Set the release cycle of dmon data',
  'app.mqtt.variable.flexem_push_mode.desc': 'Dmon push mode ("interval":cycle,"change":changed)',
  'app.mqtt.variable.flexem_pause.desc': 'Whether to suspend the current FBox push to the MQTT server',
  'app.mqtt.variable.flexem_fcs_ver.desc': 'Version of Fcs in FBox',
  'app.mqtt.variable.flexem_floader_ver.desc': 'Version of Floader in FBox',
  'app.mqtt.variable.flexem_fds_ver.desc': 'Version of Fcs Fds FBox',
  'app.mqtt.variable.flexem_mqtt_ver.desc': 'This data segment represents the code version of MQTT in FBox',
  'app.mqtt.variable.flexem_sn.desc': 'FBox/HMI SN',
  'app.mqtt.variable.flexem_password.desc': 'FBox/HMI password',
  'app.mqtt.variable.flexem_online_sta.desc': 'FBox online state',
  'app.mqtt.variable.flexem_net_type.desc': 'FBox network type',
  'app.mqtt.variable.flexem_wireless.desc': 'FBox wireless signal strength',
  'app.mqtt.variable.flexem_vnc_op_password.desc': 'VNC operate password',
  'app.mqtt.variable.flexem_vnc_mo_password.desc': 'VNC monitor password',
  'app.mqtt.variable.flexem_connect_sta.desc': 'Network connect state',
  'app.mqtt.variable.flexem_sd_card_sta.desc': 'SD card insert status',
  'app.mqtt.variable.flexem_usb_sta.desc': 'U disk insertion status',
  'app.mqtt.variable.flexem_usb_down_line_sta.desc': 'USB download cable connection status',
  'app.mqtt.variable.flexem_picture_base64.desc': 'Picture Information(Format:Base64)',
  'app.mqtt.variable.flexem_reboot.desc': 'Whether to restart FBox',
  'app.mqtt.variable.flexem_push_alarm.desc': 'Whether alarm information reporting function is enabled',
  'app.mqtt.variable.flexem_get_all_items.desc': 'Get data immediately and report to MQTT',
  'app.mqtt.variable.flexem_get_info.desc': 'Get FBox information("location":get location,"status":get status)',
  'app.mqtt.variable.flexem_uuid.desc': 'The UUID field reported by the device is returned to the server as is after the registration is successful',
  'app.mqtt.platform.flexem': 'Flexem',
  'app.mqtt.platform.ali_plat': 'Aliyun',
  'app.mqtt.platform.huawei_plat': 'Huawei',
  'app.mqtt.platform.onenet_plat': 'OneNet',
  'app.mqtt.platform.tencent_plat': 'Tencent',
  'app.modal.ok': 'Ok',
  'app.modal.cancel': 'Cancel',
  'app.modal.save': 'Save',
  'app.modal.abandon': 'Abandon',
  'app.modal.import': 'Import',
  'app.modal.confirm.delete': 'Are you sure to delete this record?',
  'app.modal.confirm.delete.forbidden': 'This item cannot be deleted.',
  'app.modal.confirm.edit.forbidden': 'This item cannot be edited.',
  'app.modal.reboot.confirm': 'The configuration has been updated successfully, Confirm to reboot the box to take effect?',
  'app.modal.reboot.countDown': 'The box is rebooting. Please operate in {second} seconds.。',
  'app.modal.reboot.message': 'The box is rebooting....',
  'app.modal.title': 'System prompt',
  'app.device.code.unknown': 'Unknown error.',
  'app.device.code.0': 'Finish',
  'app.device.code.1': 'Device timeout.',
  'app.device.code.2': 'System error.',
  'app.device.code.3': 'Insufficient disk space.',
  'app.device.code.4': 'Exec command failed.',
  'app.device.code.5': 'Device com not connected.',
  'app.device.code.6': 'Json Deserialize Failed',
  'app.device.code.7': 'File Md5 Check Failed.',
  'app.device.code.101': 'Open USB failed.',
  'app.device.code.102': 'Open USB failed.',
  'app.device.code.103': 'Write data failed',
  'app.device.code.104': 'Read data failed.',
  'app.device.code.105': 'Parse data failed.',
  'app.device.code.106': 'Forbidden to execute this command.',
  'app.device.code.107': 'Exec command failed.',
  'app.device.code.108': 'Exec command failed.',
  'app.device.code.109': 'Unsupported command.',
  'app.device.code.110': 'Connect failed.',
  'app.device.code.1001': 'Firmware does not support plc.',
  'app.device.code.1002': 'Firmware does not support variable.',
  'app.device.code.1003': 'Firmware does not support mqtt transfer.',
  'app.device.code.1004': 'Firmware does not support upgrade feature.',
  'app.device.code.1005': 'Firmware does not support network feature.',
  'app.device.code.1006': 'Firmware does not support NTP feature.',
  'app.device.code.1007': 'Firmware does not support APN feature.',
  'app.device.code.1008': 'Firmware does not support connection setting.',
  'app.device.code.1009': 'Firmware does not support VPN.',
  'app.device.code.1010': 'Firmware does not support alarm.',
  'app.device.code.1011': 'Firmware does not support macro.',
  'app.device.code.9000': 'connect.mode file not exists.',
  'app.device.code.9001': 'Open connect.mode file failed.',
  'app.device.code.9002': 'Device mode is not SE.',
  'app.device.code.9003': 'File transfer timeout.',
  'app.device.code.9004': 'File MD5 check failed.',
  'app.device.code.9005': 'The file is invalid or does not exist.',
  'app.device.code.9006': 'Allocate file memory failed.',
  'app.device.code.10011': 'Plc download failed.',
  'app.device.code.10012': 'Plc drive update failed.',
  'app.device.code.10013': 'Incorrect plc download url.',
  'app.device.code.10014': 'Failed to save plc config file.',
  'app.device.code.10015': 'Plc unknown device mode.',
  'app.device.code.20001': 'Register data monitor failed.',
  'app.device.code.20002': 'Init plc config file error.',
  'app.device.code.30001': 'Mqtt config file error.',
  'app.device.code.30002': 'Failed to save mqtt config file.',
  'app.device.code.40001': 'Failed to execute reboot command.',
  'app.device.code.40002': 'Unknown command.',
  'app.device.code.40003': 'Command json format error.',
  'app.device.code.50001': 'Unknown firmware file.',
  'app.device.code.50002': 'Download firmware file failed.',
  'app.device.code.50003': 'Firmware file MD5 check failed.',
  'app.device.code.50004': 'Failed to open firmware file.',
  'app.device.code.50005': 'Unknown file type.',
  'app.device.code.50006': 'Firmware file authorization check failed.',
  'app.device.code.60001': 'Box basic info config file error.',
  'app.device.code.60002': 'Failed to save box basic info config file.',
  'app.device.code.80001': 'Failed to parse json protocol.',
  'app.device.code.80002': 'Failed to save json file.',
  'app.device.code.80003': 'Failed to read config file.',
  'app.device.code.80004': 'Failed to write config file.',
  'app.device.code.90001': 'Failed to parse writing data json file.',
  'app.device.code.90002': 'Failed to parse variable id.',
  'app.device.code.90003': 'Failed to write variable data.',
  'app.device.code.100001': 'Failed to open VPN connection.',
  'app.device.code.100002': 'Failed to close VPN connection',
  'app.device.code.100003': 'Failed to connect VPN server.',
  'app.device.code.100004': 'Invalid VPN drive download url.',
  'app.device.code.100005': 'Invalid VPN drive md5.',
  'app.device.code.110001': 'Failed to register alarm variable.',
  'app.device.code.10000000': 'Invalid parameters',
  'app.device.code.10000001': 'System initialization error.',
  'app.device.code.10000002': 'Invalid mqtt connection.',
  'app.device.code.10000003': 'The requested data does not exist.',
  'app.device.code.10000004': 'Duplicate name.',
  'app.device.code.10000005': 'No permission to access.',
  'app.device.code.10000006': 'Command exec failed.',
  'app.device.code.10000007': 'System Error.',
  'app.device.code.10000008': 'USB is not connected.',
  'app.device.code.10000009': 'JSON parsing failed.',
  'app.device.code.10001000': 'Serial number: {boxNo} already exists.',
  'app.device.code.10001001': 'Serial number: {boxNo} was addedd by other users.',
  'app.device.code.10001002': 'Device not exist.',
  'app.device.code.10001003': 'Device is offline.',
  'app.device.code.10001004': 'Device firmware is being upgraded.',
  'app.device.code.10001005': 'Device firmware does not support.',
  'app.device.code.10001006': 'Device is Resetting.',
  'app.device.code.10001007': 'Device option does not support.',
  'app.device.code.10001008': 'Device floader version is too low.',
  'app.device.code.10001009': 'Device mode does not support.',
  'app.device.code.10001010': 'Device type does not support.',
  'app.device.code.10001011': 'Device is busy. Please try again later.',
  'app.device.code.10001012': 'Only devices of the same type can be upgraded at the same time when upgrading firmware in batch.',
  'app.device.code.10001100': 'Device firmware does not support this feature.',
  'app.device.code.10001200': 'Device nat ip is empty.',
  'app.device.code.10001201': 'Device info is empty.',
  'app.device.code.10001202': 'Device firmware file not found.',
  'app.device.code.10002000': 'Template apply error.',
  'app.device.code.10002001': 'Device: {boxNo} is processing, please wait...',
  'app.device.code.10002002': 'Template: {name} name already exist.',
  'app.device.code.10002003': 'Template not exist.',
  'app.device.code.10002004': 'Template plc list is empty.',
  'app.device.code.10002005': 'Template variable list is empty.',
  'app.device.code.10003000': 'User not exists.',
  'app.device.code.10003001': 'User cannot delete himself.',
  'app.device.code.10003002': 'Password can not empty.',
  'app.device.code.10003003': 'App name can not empty.',
  'app.device.code.10003004': 'App not exists.',
  'app.device.code.10003005': 'Can not delete Admin.',
  'app.device.code.10003006': 'Failed to create user.',
  'app.device.code.10003007': 'Failed to change password',
  'app.device.code.10003008': 'User not exists.',
  'app.device.code.10003009': 'Usage data exists under this user and cannot be deleted.',
  'app.device.code.10004000': 'Server internal error.',
  'app.device.code.10004005': 'VPN members exceeds the limit.',
  'app.device.code.10004006': 'Failed to create VPN network.',
  'app.device.code.10004007': 'Failed to create VPN member.',
  'app.device.code.10004008': 'VPN api calling exception.',
  'app.device.code.10004009': 'Failed to open VPN.',
  'app.device.code.10004010': 'Failed to close VPN.',
  'app.device.code.10004011': 'The app secret does not support getting firmware, please contact the admin to reapply.',
  'app.device.code.10004012': 'The app secret does not support getting drive, please contact the admin to reapply.',
  'app.device.code.10004013': 'The app secret does not support VPN, please contact the admin to reapply.',
  'app.device.code.10004014': 'Invalid box',
  'app.device.code.10004015': 'VPN depend file missing.',
  'app.device.code.10004016': 'Box authorize failed.',
  'app.device.code.10004017': 'The request frequency is too fast and the request is limited.',
  'app.device.code.10004018': 'Driver file not found.',
  'app.device.code.10004019': 'Device firmware file not found.',
  'app.device.code.10005000': 'PMS service invocation exception.',
  'app.device.code.10005001': 'Device information not found.',
  'app.device.code.10005002': 'PMS server returned data error.',
}
